// Details shown on the legal pages (Privacy Policy, Terms) and contact links.
export const LEGAL = {
  site: "PartyCade",
  url: "https://www.partycade.lol",
  // contact@ for general, privacy and legal questions; support@ for help and
  // reports about players or content.
  contact: "contact@partycade.lol",
  support: "support@partycade.lol",
  updated: "2026-09-30", // Shown in each language's date format.
  // Who runs the site, for the Impressum (German law, § 5 DDG, needs a name and
  // a postal address where letters reach them; a P.O. box isn't enough).
  operator: {
    name: "Yahia Taha",
    street: null, // Street and number, e.g. from an Impressum address service.
    city: "74074 Heilbronn",
    country: "Germany",
    countryDe: "Deutschland",
  },
  // The Terms' governing law.
  country: "Germany",
  // The data protection authority responsible for the operator.
  authority: {
    name: "Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg",
    url: "https://www.baden-wuerttemberg.datenschutz.de",
  },
  minAge: 16,
};
